<app-card showHeader="false" padding="0" headerClass="p-0 sticky-header bg-accent-50">
  <ng-template #headerTitleTemplate>
    <div class="py-1 product-block">
      <div class="product-block-header">

        <div class="table-button-row " style="padding-left: 10px; padding-right: 10px">
          @for (action of actions; track action) {
            @if (action.link && (action | tableDataSetLink: getExtraData(null))) {
              <a
                [routerLink]="action | tableDataSetLink: getExtraData(null)"
                mat-raised-button
                color="primary"
                class="b-rad-20"
                [disabled]="action | tableDataSetDisable: getExtraData(null)"
              >
                <div class="flex align-item-center">
                  <i class="{{action.icon + ' ti f-18 m-r-10'}}"></i>
                  {{ action.label || action.key }}
                </div>
              </a>
            } @else {
              <button
                [disabled]="action | tableDataSetDisable: getExtraData(null)"
                (click)="pressAction(action)"
                mat-raised-button
                color="primary" class="b-rad-20"
              >
                <div class="flex align-item-center">
                  <i class="{{action.icon + ' ti f-18 m-r-10'}}"></i>
                  {{ action.label || action.key }}
                </div>
              </button>
            }
          }

        </div>
      </div>

    </div>

    <div class="table-button-row px-3">

      <button mat-button (click)="drawerFilter.toggle()">
        <div class="flex align-item-center">
          @if (isLoading) {
            <i class="ti ti-loader f-18 m-r-10"></i>
            Cargando datos ...
          } @else {
            <i class="ti ti-filter f-18 m-r-10"></i>
            @switch (filterCount) {
              @case (0) {
                Filtrar
              }
              @case (1) {
                1 Filtro aplicado
              }
              @default {
                {{ filterCount }} Filtros aplicados
              }
            } | {{ countFindElements }} {{ countFindElements === 1 ? 'elemento' : 'elementos' }}
          }
        </div>
      </button>

      <!--<mat-chip>
        <strong>Tipo</strong> Prueba
      </mat-chip>-->
    </div>
  </ng-template>

  <div class="table-responsive">
    <table mat-table [dataSource]="sources" class="mat-elevation-z8">
      <ng-container matColumnDef="$select">
        <th mat-header-cell width="50" *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            [checked]="selectedElements.has(element)"
            (click)="toggleSelect(element)">
          </mat-checkbox>

        </td>
      </ng-container>

      @for (column of columns; track column) {
        <ng-container [matColumnDef]="column.key">
          <th mat-header-cell *matHeaderCellDef>
            {{ column.label || column.key }}
          </th>

          <td mat-cell *matCellDef="let element;" (click)="onlySelect(element)">
            <span class="text-truncate w-100 f-w-500" [innerHTML]="element.$update | tableCellRender: getExtraData(element): column ">
            </span>
          </td>
        </ng-container>
      }

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Acciones</th>
        <td mat-cell *matCellDef="let element">
          @for (action of actionsInRow; track action) {
            @if (action.link && (action | tableDataSetLink: getExtraData(element))){
              <a mat-icon-button color="primary" class="b-rad-20" [routerLink]="action | tableDataSetLink: getExtraData(element)">
                <i class="{{action.icon + ' ti f-18 m-r-10'}}"></i>
              </a>
            }@else{
              <button mat-icon-button color="primary" class="b-rad-20" (click)="pressAction(action, [element])">
                <i class="{{action.icon + ' ti f-18 m-r-10'}}"> </i>
              </button>
            }
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnKeys"></tr>
      <tr mat-row
          *matRowDef="let row; columns: columnKeys;  let rowNumber = index"
          [class.row-is-select]="selectedElements.has(row)"
          (ngxVisibility)="onVisible(row, $event, rowNumber)"
      >
      </tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">No data matching the filter</td>
      </tr>
    </table>
  </div>


</app-card>

<div class="text-center">
  @if (isLoading) {
    <button
      mat-raised-button
      color="primary"
      class="b-rad-20"
    >
      <div class="flex align-item-center">
        <i class="ti ti-loader f-18 m-r-10"></i>
        Cargando datos ...
      </div>
    </button>
  }
</div>

<mat-drawer #drawerFilter position="end" class="notification-status sidenav" mode="over" style="z-index: 9999999">
  <div class="drawer-header">
    <div class="f-16 f-w-600">Filtrar elementos</div>
    <button type="button" mat-icon-button class="close-drawer" (click)="drawerFilter.toggle()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <ng-scrollbar style="height: calc(100vh - 88px)" visibility="hover">
    @if(filterFields){
      <app-filter-data-set [fields]="filterFields" [valueRecord]="filterValueRecord" (valueRecordChange)="onChangeFilterValues($event)" />
    }
  </ng-scrollbar>
</mat-drawer>

